<template>
  <div>
    <top />
    <!-- 领域分类 -->
    <div class="subnav_box home mt30" v-if="windowWidth > 769">
      <div class="subnav">
        <i></i>
        <span>领域分类</span>
        <!-- <div class="down_btn fr">
          <a href>
            <img src="@/assets/imgs/down.png" />
          </a>
        </div>-->
      </div>

      <div class="cd_box clearfix">
        <div class="fl linecss" v-for="fieldItem in FieldsMenu" :key="fieldItem.uid">
          <template v-if="fieldItem.uid != '9008'">
            <h2 class="icon icon_css">{{ fieldItem.text }}</h2>
            <ul>
              <li v-for="item in fieldItem.newChildren" :key="item.uid">
                <router-link :to="{
                  path: '/allReports',
                  query: { id: item.uid, idname: item.text },
                }" @click.native="getHomeFieldname(item.text)" class="a"
                  :class="{ 'icon_new_my': shouldShowIconClass(item.text) }"
                  v-show="item.isPresent">{{
                    item.text
                  }}</router-link>

              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>

    <!-- 报告 -->
    <div class="content home">
      <!-- 热点报告 -->
      <div class="page1">
        <div class="title clearfix">
          <a href="javascript:;" class="fl cursor">
            <h2>热点报告</h2>
          </a>
          <router-link :to="{ name: 'weekReport', query: { uid: '热点报告' } }" class="fr">
            <span class="more">更多&gt;&gt;</span>
          </router-link>
        </div>
        <ul class="clearfix">
          <li class="line" v-for="item in hotDocs" :key="item.code" :title="item.title">
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
              item.chnid +
              '&leafid=' +
              item.leafid +
              '&docid=' +
              item.code.substring(4, item.code.length) +
              '&uid=' +
              item.uid +
              '&version=dReport'
              " target="_blank">
              <img
                :src="imageExists(item.chnid) ? require(`@/assets/imgs/report_imgs/${item.chnid}.jpg`) : require(`@/assets/imgs/report_imgs/Default.png`)"
                class="box_ul_img" />
            </a>
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
              item.chnid +
              '&leafid=' +
              item.leafid +
              '&docid=' +
              item.code.substring(4, item.code.length) +
              '&uid=' +
              item.uid +
              '&version=dReport'
              " target="_blank" class="h1">{{ item.title }}</a>
            <div class="clear"></div>
          </li>
        </ul>
      </div>

      <!-- 周评 -->
      <div class="page2">
        <div class="title clearfix" style="margin-top: 10px">
          <a href="javascript:;" class="fl cursor">
            <h2>周评</h2>
          </a>
          <router-link :to="{ name: 'weekReport', query: { uid: '周评' } }" class="fr">
            <span class="more">更多&gt;&gt;</span>
          </router-link>
        </div>

        <ul class="zp_ul clearfix">
          <li class="zp_li" v-for="item in weekDocs" :key="item.code">
            <img src="@/assets/imgs/fm.jpg" />
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
              item.chnid +
              '&leafid=' +
              item.leafid +
              '&docid=' +
              item.code.substring(4, item.code.length) +
              '&uid=' +
              item.uid +
              '&version=dReport'
              " target="_blank" class="zp_a">
              <h2>
                {{ item.title.slice(0, item.title.indexOf("（")) }}
              </h2>
              <span>{{
                item.title.slice(
                  item.title.indexOf("（") + 1,
                  item.title.indexOf("）")
                )
              }}</span>
            </a>
          </li>
        </ul>
        <div class="clear"></div>
      </div>

      <!-- 月度报告 -->
      <div class="page3">
        <div class="title clearfix" style="margin-top: 10px">
          <a href="javascript:;" class="fl cursor">
            <h2>月度报告</h2>
          </a>
          <router-link :to="{ name: 'weekReport', query: { uid: '月度报告' } }" class="fr">
            <span class="more">更多&gt;&gt;</span>
          </router-link>
        </div>
        <div class="clearfix">
          <img :src="indexImgURL +
            '/www/ydyl/ImageShow.ashx?docId=' +
            (monthDocsFirst.code || '').substring(
              4,
              (monthDocsFirst.code || '').length
            ) +
            '&purposeId=2'
            " class="box_ul_img fl" />
          <div class="t_box fr">
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
              monthDocsFirst.chnid +
              '&leafid=' +
              monthDocsFirst.leafid +
              '&docid=' +
              (monthDocsFirst.code || '').substring(
                4,
                (monthDocsFirst.code || '').length
              ) +
              '&uid=' +
              monthDocsFirst.uid +
              '&version=dReport'
              " target="_blank">
              <h1>{{ monthDocsFirst.title }}</h1>
            </a>
            <p>
              <span>{{ monthDocsFirst.summary }}</span>
              <span>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                  monthDocsFirst.chnid +
                  '&leafid=' +
                  monthDocsFirst.leafid +
                  '&docid=' +
                  (monthDocsFirst.code || '').substring(
                    4,
                    (monthDocsFirst.code || '').length
                  ) +
                  '&uid=' +
                  monthDocsFirst.uid +
                  '&version=dReport'
                  " target="_blank" class="xq">[详情]</a>
              </span>
            </p>
          </div>
          <div class="clear"></div>
          <ul class="yb_main_ul">
            <li v-for="item in monthDocs" :key="item.code" class="fl clearfix">
              <a :href="indexLinkURL +
                '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                item.chnid +
                '&leafid=' +
                item.leafid +
                '&docid=' +
                (item.code || '').substring(4, (item.code || '').length) +
                '&uid=' +
                item.uid +
                '&version=dReport'
                " target="_blank" class="fl">
                <span>◎</span>
                {{ item.title }}
              </a>
              <p class="fr">{{ item.deliveddate }}</p>
            </li>
          </ul>
        </div>
      </div>

      <!-- 季度报告 -->
      <div class="page3">
        <div class="title clearfix" style="margin-top: 10px">
          <a href="javascript:;" class="fl cursor">
            <h2>季度报告</h2>
          </a>
          <router-link :to="{ name: 'weekReport', query: { uid: '季度报告' } }" class="fr">
            <span class="more">更多&gt;&gt;</span>
          </router-link>
        </div>
        <div class="clearfix">
          <img :src="indexImgURL +
            '/www/ydyl/ImageShow.ashx?docId=' +
            (quarterDocsFirst.code || '').substring(
              4,
              (quarterDocsFirst.code || '').length
            ) +
            '&purposeId=2'
            " class="box_ul_img fl" />
          <div class="t_box fr">
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
              quarterDocsFirst.chnid +
              '&leafid=' +
              quarterDocsFirst.leafid +
              '&docid=' +
              (quarterDocsFirst.code || '').substring(
                4,
                (quarterDocsFirst.code || '').length
              ) +
              '&uid=' +
              quarterDocsFirst.uid +
              '&version=dReport'
              " target="_blank">
              <h1>{{ quarterDocsFirst.title }}</h1>
            </a>
            <p>
              <span>{{ quarterDocsFirst.summary }}</span>
              <span>
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                  quarterDocsFirst.chnid +
                  '&leafid=' +
                  quarterDocsFirst.leafid +
                  '&docid=' +
                  (quarterDocsFirst.code || '').substring(
                    4,
                    (quarterDocsFirst.code || '').length
                  ) +
                  '&uid=' +
                  quarterDocsFirst.uid +
                  '&version=dReport'
                  " target="_blank" class="xq">[详情]</a>
              </span>
            </p>
          </div>
          <div class="clear"></div>
          <ul class="yb_main_ul">
            <li v-for="item in quarterDocs" :key="item.code" class="fl clearfix">
              <a :href="indexLinkURL +
                '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                item.chnid +
                '&leafid=' +
                item.leafid +
                '&docid=' +
                (item.code || '').substring(4, (item.code || '').length) +
                '&uid=' +
                item.uid +
                '&version=dReport'
                " target="_blank" class="fl">
                <span>◎</span>
                {{ item.title }}
              </a>
              <p class="fr">{{ item.submitDate.slice(0, 10) }}</p>
            </li>
          </ul>
        </div>
      </div>

      <!-- 年度报告 -->
      <div class="page5">
        <div class="title clearfix" style="margin-top: 10px">
          <a href="javascript:;" class="fl cursor">
            <h2>年度报告</h2>
          </a>
          <router-link :to="{ name: 'yearReport', query: { uid: '年度报告' } }" class="fr">
            <span class="more">更多&gt;&gt;</span>
          </router-link>
        </div>
        <div @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
          <swiper ref="mySwiper" :options="swiperOption" v-if="windowWidth > 769">
            <swiper-slide v-for="item in yearDocs" :key="item.code">
              <li class="slide_li">
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                  item.chnid +
                  '&leafid=' +
                  item.leafid +
                  '&docid=' +
                  item.code.substring(4, (item.code || '').length) +
                  '&uid=' +
                  item.uid +
                  '&version=dReport'
                  " target="_blank" class="w178">
                  <div class="txtwarp w167 h86">
                    <span>{{ item.title.slice(0, 11) }}</span>
                    <p>{{ item.title.slice(11) }}</p>
                  </div>
                  <img :src="indexImgURL +
                    '/www/ydyl/ImageShow.ashx?docId=' +
                    item.code.substring(4, (item.code || '').length) +
                    '&purposeId=2'
                    " />
                </a>
              </li>
            </swiper-slide>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
          </swiper>
          <swiper ref="mySwiper" :options="mSwiperOption" v-if="windowWidth < 769">
            <swiper-slide v-for="item in yearDocs" :key="item.code">
              <li class="slide_li">
                <a :href="indexLinkURL +
                  '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                  item.chnid +
                  '&leafid=' +
                  item.leafid +
                  '&docid=' +
                  item.code.substring(4, (item.code || '').length) +
                  '&uid=' +
                  item.uid +
                  '&version=dReport'
                  " target="_blank" class="w178">
                  <div class="txtwarp w167 h86">
                    <span>{{ item.title.slice(0, 11) }}</span>
                    <p>{{ item.title.slice(11) }}</p>
                  </div>
                  <img :src="indexImgURL +
                    '/www/ydyl/ImageShow.ashx?docId=' +
                    item.code.substring(4, (item.code || '').length) +
                    '&purposeId=2'
                    " />
                </a>
              </li>
            </swiper-slide>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
          </swiper>
        </div>
      </div>
      <!-- 专题报告 -->
      <div class="page6">
        <div class="title clearfix" style="margin-top: 10px">
          <a href="javascript:;" class="fl cursor">
            <h2>专题报告</h2>
          </a>
          <!-- <a href class="fr">
            <span class="more">更多&gt;&gt;</span>
          </a>-->
        </div>
        <ul class="zt_ul">
          <li class="zt_li" v-for="item in topicMenu" :key="item.uid" v-if="item.apptext === '互联网金融'">
            <router-link :to="{
              path: '/specialReport',
              query: { uid: item.apptext, id: item.uid },
            }" class="zt_bj_img imgcss_t">
              <a>{{ item.apptext }}</a>
            </router-link>
          </li>

          <li class="zt_li">
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26276&docid=3684000&uid=900103&version=dReport&imgShowType=1'
              " target="_blank" class="zt_bj_img imgcss_t">
              <a>智慧城市</a>
            </a>
          </li>
          <li class="zt_li">
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26277&docid=5783244&uid=900104&version=dReport&imgShowType=1'
              " target="_blank" class="zt_bj_img imgcss_t">
              <a>金融科技</a>
            </a>
          </li>
          <li class="zt_li">
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=26278&docid=5778059&uid=900105&version=dReport&imgShowType=1'
              " target="_blank" class="zt_bj_img imgcss_t">
              <a>大数据</a>
            </a>
          </li>
          <li class="zt_li">
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=6501&leafid=27053&docid=6011076&uid=900107&version=dReport&imgShowType=1'
              " target="_blank" class="zt_bj_img imgcss_t">
              <a>数字经济指数</a>
            </a>
          </li>
          <li class="zt_li">
            <a :href="indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=06501&leafid=27054&docid=6013634&uid=900108&version=dReport&imgShowType=1'
              " target="_blank" class="zt_bj_img imgcss_t">
              <a>绿色金融指数</a>
            </a>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
    <Footer />
    <!-- <div class="window" v-if="windowShow">
      <div class="close" @click="close"></div>
      <router-link :to="{ path: '/window' }" target="_blank">
        <img src="@/assets/imgs/window.png" />
      </router-link>
    </div> -->
    <!-- <div class="windows" v-if="windowsShow">
      <div class="close" @click="closes"></div>
      <router-link :to="{ path: '/windows' }" target="_blank">
        <img src="@/assets/imgs/window.jpg" />
      </router-link>
    </div> -->
  </div>
</template>

<script>
import Top from "@/components/Top";
import Footer from "@/components/Footer";
import { api } from "@/pages/index/require/api.js";
import { setFieldname } from "@/pages/index/require/auth";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      topicMenu: [],
      FieldsMenu: [],
      hotDocs: [],
      weekDocs: [],
      monthDocs: [],
      monthDocsFirst: [],
      quarterDocs: [],
      quarterDocsFirst: [],
      yearDocs: [],
      index: 0,
      falg: false,
      timer: null,
      swiperOption: {
        autoplay: 1000,
        speed: 500,
        loop: true,
        slidesPerView: 6,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        // autoplayDisableOnInteraction: false
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true // 允许点击小圆点跳转
        // },
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false // 手动切换之后继续自动轮播
        // },
        // navigation: {
        // prevButton: ".swiper-button-next",
        // nextButton: ".swiper-button-prev"
        // }
      },
      mSwiperOption: {
        autoplay: 1000,
        speed: 500,
        loop: true,
        slidesPerView: 2,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        // autoplayDisableOnInteraction: false
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true // 允许点击小圆点跳转
        // },
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false // 手动切换之后继续自动轮播
        // },
        // navigation: {
        // prevButton: ".swiper-button-next",
        // nextButton: ".swiper-button-prev"
        // }
      },
      // windowShow: true,
      // windowsShow: true,
      indexLinkURL: window.indexLinkURL,
      indexImgURL: window.indexImgURL,
    };
  },
  components: {
    Top,
    Footer,
    swiper,
    swiperSlide,
  },
  filters: {
    //文章标题截取
    summaryEllipsis(value) {
      if (!value) return "";
      if (value.length > 100) {
        return value.slice(0, 100) + "...";
      }
      return value;
    },
  },
  created() {
    this.loadsubmenu();
    this.loadFieldSorts();
    this.loadIndexDocs();
  },
  mounted() { },
  computed: {
    mySwiper() {
      // console.log(this.$refs.mySwiper);
      // mySwiper 是要绑定到标签中的ref属性
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    // 判断是否需要显示图标类
    shouldShowIconClass(text) {
      const targetItems = ['服务消费', '具身智能', '量子科技', '低空经济'];
      return targetItems.includes(text);
    },
    async loadsubmenu() {
      const { code, data } = await api.get(
        "/indexController/getChildSpecialChanels"
      );
      if (code === 0) {
        this.topicMenu = data.children;
      }
    },
    // async loadMySubscriptions() {
    //   const { code, data } = await api.get(
    //     "/indexController/getMySubscriptions"
    //   );
    //   if (code === 0) {
    //     this.mySubscriptions = data;
    //   }
    // },
    async loadFieldSorts() {
      const { code, data } = await api.get("/indexController/getFieldSorts");
      if (code === 0) {
        this.FieldsMenu = data;
      }
    },
    async loadIndexDocs() {
      const { code, data } = await api.get("/indexController/getIndexDocs", {
        uid: 90,
        reportType: "",
        currpage: 1,
        pagesize: 12,
        isIndexSearch: true,
        time: new Date().getTime(),
      });
      if (code === 0) {
        this.hotDocs =
          data.hotreport.data && data.hotreport.data.length > 0
            ? data.hotreport.data.slice(0, 6)
            : [];
        this.weekDocs =
          data.weekreport.data && data.weekreport.data.length > 0
            ? data.weekreport.data.slice(0, 6)
            : [];
        this.monthDocsFirst =
          data.monthreport.data && data.monthreport.data.length > 0
            ? data.monthreport.data.slice(0, 1)[0]
            : [];
        this.monthDocs =
          data.monthreport.data && data.monthreport.data.length > 0
            ? data.monthreport.data.slice(1, 7)
            : [];
        this.quarterDocsFirst =
          data.quarterreport.data && data.quarterreport.data.length > 0
            ? data.quarterreport.data.slice(0, 1)[0]
            : [];
        this.quarterDocs =
          data.quarterreport.data && data.quarterreport.data.length > 0
            ? data.quarterreport.data.slice(1, 7)
            : [];
        this.yearDocs =
          data.yearreport.data && data.yearreport.data.length > 0
            ? data.yearreport.data
            : [];
      }
    },
    getHomeFieldname(val) {
      setFieldname(val);
    },

    // 轮播图 ------------------
    on_bot_enter() {
      console.log(this.mySwiper);
      this.mySwiper.stopAutoplay();
    },
    on_bot_leave() {
      this.mySwiper.startAutoplay();
    },
    // 轮播图 ------------------
    close() {
      this.windowShow = false;
    },
    closes() {
      this.windowsShow = false;
    },
    // 判断图片是否存在
    imageExists(chnid) {
      try {
        // 尝试 require 图片
        require(`@/assets/imgs/report_imgs/${chnid}.jpg`);
        return true;
      } catch (e) {
        return false;
      }
    }
  },
};
</script>

<style lang="less" scoped>
// 领域分类
.subnav_box {
  border: 1px solid #2994d0;

  .subnav {
    height: 40px;
    background: #2994d0;
    width: 100%;

    i {
      background: url(../../../assets/imgs/cdimg.png) no-repeat;
      width: 14px;
      height: 14px;
      float: left;
      margin-left: 15px;
      margin-top: 13px;
      margin-right: 10px;
    }

    span {
      color: #fff;
      font-size: 16px;
      padding-top: 8px;
      display: block;
      float: left;
    }

    .down_btn img {
      width: auto;
      height: auto;
      margin-right: 15px;
      margin-top: 12px;
    }
  }

  .cd_box {
    padding: 25px 0px 25px 25px;

    .linecss {
      border-left: 1px dashed #a4a4a4;
      margin-left: 13px;

      // height: 370px;
      ul {
        .a {
          padding-left: 24px;
          color: #373737;
          font-size: 15px;
          line-height: 30px;
        }

        .a:hover {
          color: #0770b9;
        }
      }
    }

    .linecss+.linecss {
      margin-left: 39px;
    }
  }
}

.linecss:nth-child(7) {
  ul {
    width: 324px;
    overflow: hidden;

    li {
      float: left;
      width: 162px;
    }
  }
}

// 报告
.title {
  border-bottom: 1px solid #ccc;
  margin-bottom: 15px;
  margin-top: 20px;
}

.title h2 {
  font-size: 18px;
  border-bottom: 2px solid #0770b9;
  line-height: 30px;
  display: inline-block;
  padding: 5px;
  color: #0770b9;
  font-weight: 600;
  position: relative;
  bottom: -1px;
}

.title .more {
  line-height: 30px;
  font-size: 14px;
  color: #999;
  padding-top: 12px;
  display: block;
}

.title .more:hover {
  color: #0770b9;
}

img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.box_ul_img {
  width: 240px;
  height: 137px;
  border: 1px solid #dddddd;
}

.xq {
  color: #c00;
}

// 热点报告
.page1 {
  ul {
    .line {
      margin: 15px 0;
      padding-right: 20px;
      width: 33.3%;
      float: left;

      img {
        width: 100%;
        height: 200px;
        transition: all 0.2s ease;
      }

      img:hover {
        box-shadow: 0px 0px 10px black;
        cursor: pointer;
      }

      .h1 {
        display: block;
        font-size: 19px;
        color: #004276;
        padding: 10px;
        overflow: hidden;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .h1:hover {
        color: #0770b9 !important;
      }

      .t_box {
        width: 310px;
      }

      p {
        text-align: justify;

        span {
          line-height: 24px;
        }
      }
    }

    // .line:nth-child(2n) {
    //   float: right;
    // }
    // .line:nth-child(2n-1) {
    //   float: left;
    // }
  }
}

// 周评
.page2 {
  .zp_ul {
    .zp_li {
      background: url(../../../assets/imgs/fm.jpg) no-repeat;
      width: 178px;
      height: 227px;
      float: left;
      position: relative;
      transition: all 0.2s ease;

      .zp_a {
        top: 30px;
        position: absolute;
        width: 100%;

        h2 {
          width: 135px;
          display: block;
          margin: 0 auto;
          text-align: center;
          font-size: 17px;
          color: #fff;
          margin-top: 30px;
          height: 160px;
          margin: 0 auto;
        }

        span {
          display: block;
          margin: 0 auto;
          width: 180px;
          text-align: center;
          color: #2d8ac3;
        }
      }
    }

    .zp_li:hover {
      box-shadow: 0px 0px 10px #666666;
    }
  }
}

.zp_li+.zp_li {
  margin-left: 26px;
}

// 月度/季度报告
.page3 {
  .t_box {
    width: 935px;
    margin-left: 25px;

    h1 {
      font-size: 19px;
      color: #004276;
      padding-bottom: 10px;
      padding-top: 10px;
    }

    p {
      text-align: justify;
    }
  }

  .yb_main_ul {
    width: 100%;
    margin-top: 15px;

    li {
      line-height: 32px;
      width: 48%;

      a {
        color: #333;
        font-size: 15px;

        span {
          color: #999;
          font-size: 16px;
          padding-right: 3px;
        }
      }

      p {
        color: #666;
      }
    }

    li:nth-child(2n-1) {
      float: left;
    }

    li:nth-child(2n) {
      float: right;
    }
  }
}

// 年度报告
.page5 {
  li {
    width: 200px;
    height: 227px;

    a {
      display: block;
      position: relative;
      width: 178px;
      height: 100%;
      padding: 4px;
      border: 1px solid #dfdfdf;
      color: #fff;
      margin: 0px 11px;

      .txtwarp {
        position: absolute;
        background: url(../../../assets/imgs/fm_s.jpg) no-repeat;
        width: 168px;
        height: 86px;
        background-size: 100%;
        text-align: center;
        padding-top: 20px;
        z-index: 99;

        p {
          font-size: 16px;
          overflow: hidden;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 4px;
        }
      }

      img {
        position: absolute;
        z-index: 9;
        width: 168px;
        height: 217px;
      }
    }
  }
}

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }
// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }

.swiper-container {
  width: 1200px;
  background: #fff;
  height: 227px;
}

.swiper-slide {
  width: 200px;
  /*设为固定值*/
}

.slide_li {
  list-style: none;
}

// .swiper-button-prev:hover,.swiper-button-next:hover {
//   // background: #333;
//   // opacity: .9;
//   background: url(../../../assets/imgs/slider_bn_bg.png) no-repeat 0 0;
//       width: 30px;
//     height: 75px;
// }
//专题报告
.page6 {
  .zt_ul {
    .imgcss_t {
      display: block;
      width: 280px;
      height: 175px;
      text-align: center;
      float: left;
      transition: all 0.2s ease;

      a {
        line-height: 175px;
        color: #fff;
        font-size: 17px;
      }
    }

    .imgcss_t:hover {
      box-shadow: 0px 0px 15px black;
    }
  }
}

.zt_li:nth-child(1) .zt_bj_img {
  background: url(../../../assets/imgs/imgf4_1.jpg) no-repeat;
}

.zt_li:nth-child(2) .zt_bj_img {
  background: url(../../../assets/imgs/imgf4_2.jpg) no-repeat;
}

.zt_li:nth-child(3) .zt_bj_img {
  background: url(../../../assets/imgs/imgf4_3.jpg) no-repeat;
}

.zt_li:nth-child(4) .zt_bj_img {
  background: url(../../../assets/imgs/imgf4_4.jpg) no-repeat;
}

.zt_li:nth-child(5) .zt_bj_img {
  background: url(../../../assets/imgs/imgf4_5.jpg) no-repeat;
  margin-top: 20px;
}

.zt_li:nth-child(6) .zt_bj_img {
  background: url(../../../assets/imgs/imgf4_6.jpg) no-repeat;
  margin-top: 20px;
}

.zt_li+.zt_li {
  margin-left: 26px;
  width: 280px;
  float: left;
}

.zt_li:nth-child(5) {
  margin-left: 0px;
}

// 飘窗
.window {
  position: fixed;
  z-index: 9999;
  right: 0px;
  bottom: 10px;
}

.close {
  height: 20px;
  width: 20px;
  background: url(../../../assets/imgs/close.png) no-repeat;
  top: 5px;
  position: absolute;
  right: 5px;
  cursor: pointer;
}

.windows {
  position: fixed;
  z-index: 9999;
  left: 0px;
  bottom: 10px;
}

@media screen and (max-width: 769px) {
  .home {
    padding: 0 16px;
  }

  .page1 {
    ul {
      .line {
        padding-right: 0;
        width: 49%;

        &:nth-child(2n) {
          padding-right: 0;
          margin-left: 2%;
        }

        .h1 {
          font-size: 14px;
          padding: 10px 0;
        }
      }
    }
  }

  .page2 {
    .zp_ul {
      .zp_li {
        width: 50%;

        a {
          span {
            display: inline-block !important;
            width: 100% !important;
          }
        }
      }
    }
  }

  .zp_li+.zp_li {
    margin-left: 0;
  }

  .box_ul_img {
    width: 100%;
  }

  .page3 {
    .t_box {
      width: 100%;
    }

    .yb_main_ul {
      li {
        width: 100%;

        a {
          width: calc(100% - 95px);
          overflow: hidden;
          /*超出部分隐藏*/
          white-space: nowrap;
          /*不换行*/
          text-overflow: ellipsis;
          /*超出部分文字以...显示*/
        }

        p {
          width: 90px;
          text-align: right;
        }
      }
    }
  }

  .swiper-container {
    width: 100%;
  }

  .page6 {
    .zt_ul {
      .zt_li {
        width: 50%;
        margin: 0;

        .imgcss_t {
          width: 100%;
          height: auto;
        }

        .zt_bj_img {
          margin: 0;
        }
      }
    }
  }
}

.icon_new_my {
  position: relative;
}

.icon_new_my::after {
  width: 28px;
  height: 11px;
  content: url(../../../assets/imgs/newIcon.gif);
  position: absolute;
  right: -28px;
}

// .icon_new_my {
//   display: inline-block;
//   width: 28px;
//   height: 11px;
//   background: url(../../../assets/imgs/newIcon.gif) no-repeat;

// }</style>
